import { ChangelogEntry } from './changelog-entry';
import dayjs from 'dayjs';
import * as uuid from 'uuid';
import { StandardEntity } from '../../engine/standard-entity';

export class ChangelogVersion extends StandardEntity {
  public override id: string;
  public date: Date;
  public title: string;
  public entries: ChangelogEntry[] = [];
  public isNew = true;

  constructor(id: string, date: Date, title: string) {
    super();
    this.id = id ?? uuid.v4();
    this.date = date;
    this.title = title;
  }

  public toTitle(): string {
    return `${dayjs(this.date).format('DD/MM/YYYY')} - ${this.title}`;
  }
}
